import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";

/**
 * Handles the Google OAuth callback from Emergent Auth.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
 * THIS BREAKS THE AUTH.
 */
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { completeGoogleSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    const prospectId = localStorage.getItem("ph_prospect_id");

    (async () => {
      if (!sessionId) {
        toast.error("Session Google introuvable. Réessayez.");
        navigate("/", { replace: true });
        return;
      }
      if (!prospectId) {
        toast.error("Merci de remplir d'abord vos coordonnées.");
        navigate("/", { replace: true });
        return;
      }
      try {
        const data = await completeGoogleSession(sessionId, prospectId);
        // Clean the URL and the temporary prospect_id (kept for potential re-auth)
        window.history.replaceState({}, document.title, "/dashboard");
        toast.success(
          data.new_user ? "Votre espace membre est prêt ✨" : "Connexion réussie",
        );
        navigate("/dashboard", { replace: true });
      } catch (err) {
        toast.error(formatApiError(err, "L'authentification Google a échoué."));
        navigate("/register", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-ph" data-testid="auth-callback">
      <div className="text-center">
        <div className="text-[#C9A45C] text-xs tracking-[0.3em] uppercase mb-3">Authentification</div>
        <div className="font-serif-lux text-2xl text-white">Ouverture de votre espace…</div>
        <div className="mt-6 h-1 w-40 mx-auto bg-[#FFFFFF] border border-[#E4E7EC] overflow-hidden">
          <div className="h-full w-1/2 bg-gradient-to-r from-[#A2823F] to-[#E8D2A1] animate-pulse" />
        </div>
      </div>
    </div>
  );
}
